import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
import { addEventListener } from '@ifeng/ui_base';

class ToTop extends React.PureComponent {
    static propTypes = {
        // content: PropTypes.object,
    };

    handleClick = () => {
        window.scroll(0, 0);
    };

    render() {
        return (
            <div className={styles.toTop}>
                <div className={styles.erweima}>
                    <img
                        src="https://x0.ifengimg.com/ucms/qr/2019_50/8294530134E6103B52EBA649EEC4461613433B60_w280_h280.png"
                        alt=""
                    />
                    <div className={styles.erweima_content}>下载客户端 独家抢先看</div>
                </div>
                <div className={styles.back_home}>
                    <div className={styles.back_top} onClick={this.handleClick}>
                        <div className={styles.back_content}>返回</div>
                        <div className={styles.back_content_img}>
                            <img src="http://p3.ifengimg.com/a/2017/1129/shape81.png" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ToTop;
